import React from 'react';
import { register } from '../../i18n';

const t = register('GlobalQuestionLabels');

const SubmissionWarningDialog = ({ isOpen, onConfirm, onCancel, message }) => {
  if (!isOpen) return null;

  return (
    <div className="submission-warning-overlay">
      <div className="submission-warning-dialog">
        <div className="submission-warning-header">
          <h3>{t('submissionWarning')}</h3>
        </div>
        <div className="submission-warning-body">
          <p>{message || t('submissionWarningMessage')}</p>
        </div>
        <div className="submission-warning-actions">
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            type="button"
          >
            {t('cancel')}
          </button>
          <button
            className="btn btn-primary"
            onClick={onConfirm}
            type="button"
          >
            {t('submit')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmissionWarningDialog;
